import { BaseLayout } from "layouts/common/BaseLayout";
import { MprcLayoutInside } from "layouts/common/inside/MprcLayoutInside";
import * as React from "react";
import { Outlet } from "react-router";

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const DashboardLayout: React.FC = () => {
    return (
        <BaseLayout>
            <MprcLayoutInside
                subHeaderComponent={null}
                lateralMenuComponent={null}
                subHeaderAlwaysVisible={false}
                menuOpened={false}
            >
                <Outlet />
            </MprcLayoutInside>
        </BaseLayout>
    );
};
